export default __webpack_public_path__ + "static/media/priyoRiders.97877378.png";